import { __assign, __rest } from "tslib";
import React from 'react';
import bcx from 'bem-classname';
import cx from 'classnames';
export var CheckLabel = function (props) {
    var className = props.className, isSecondary = props.isSecondary, children = props.children, id = props.id, otherProps = __rest(props, ["className", "isSecondary", "children", "id"]);
    var classes = cx(bcx('check-control', 'label', isSecondary ? 'secondary' : undefined), className);
    return (React.createElement("label", __assign({ className: classes, htmlFor: id }, otherProps), children));
};
//# sourceMappingURL=CheckLabel.js.map